/* eslint-disable max-params */
/**
 *
 * @param {string[]} maskWithoutSpecialChars An array of characters with the unfinished mask
 * @param {[string, number][]} specialCharsDescr An array of tuples. Each tuple contains a string and a position (What string to add in a particular position)
 * @param {number} maskedPos Current masked position
 * @param {string} lastKeyCode Last key code of the user
 * @returns {[string, number]} A tuple containing the final mask and the final masked position
 */
export const addSpecialCharacters = (
  maskWithoutSpecialChars: string[],
  specialCharsDescr: [string, number][],
  maskedPos: number,
  lastKeyCode: string,
): [string, number] => {
  const finalMask = maskWithoutSpecialChars;
  let finalMaskedPos = maskedPos;

  // We insert the special chars in the respective positions, tweaking the masked pos
  specialCharsDescr.forEach(([chars, pos]) => {
    if (finalMask.length > pos) {
      finalMask.splice(pos, 0, ...chars);
      if (finalMaskedPos >= pos) finalMaskedPos += chars.length;
    }
  });

  if (lastKeyCode !== 'Backspace' && finalMaskedPos < finalMask.length) {
    // If not erasing, move the cursor forward if we are in a special chars area
    specialCharsDescr.forEach(([chars, pos]) => {
      if (finalMaskedPos === pos) finalMaskedPos += chars.length;
    });
  } else if (lastKeyCode === 'Backspace' && finalMaskedPos) {
    // If erasing, move the cursor back if we are in a special chars area
    for (let i = specialCharsDescr.length - 1; i >= 0; i -= 1) {
      if (
        specialCharsDescr[i][1] + 1 <= finalMaskedPos &&
        finalMaskedPos <= specialCharsDescr[i][1] + specialCharsDescr[i][0].length
      )
        [, finalMaskedPos] = specialCharsDescr[i];
    }
  }

  return [finalMask.join(''), finalMaskedPos];
};
